import React from 'react'

import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

const styles = theme => ({
  root: {
    padding: 10
  },
  text: {
    paddingBottom: 10
  },
  learnMore: {},
  upgrade: {
    marginLeft: 10
  }
})

class Upgrade extends React.Component {
  render () {
    const { classes, text, url, urlLabel } = this.props

    return (
      <div className={classes.root}>
        <Typography className={classes.text} variant="body2">{text}</Typography>
        <Button className={classes.learnMore} variant="outlined" size="small" target="_blank" href={url}>
          {urlLabel}
        </Button>
        <Button className={classes.upgrade} variant="outlined" size="small" target="_blank" href="https://www.pozi.com/pricing">
          Upgrade
        </Button>
      </div>
    )
  }
}

Upgrade.propTypes = {
  classes: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  urlLabel: PropTypes.string.isRequired
}

function mapStateToProps (state, ownProps) {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Upgrade)
  )
)
